"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_1 = require("../../query");
var response_1 = require("../../response");
var retry_1 = require("../../retry");
var terminalWorkRequestStatuses = ["FAILED", "SUCCEEDED", "CANCELED"];
function defaultWorkRequestEval(_, response) {
    var workRequest = response.data;
    return terminalWorkRequestStatuses.includes(workRequest.status);
}
function watchWorkRequest(mutationArgs, workRequestFn, options, probes) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.pollingInterval, pollingInterval = _a === void 0 ? query_1.TimeInterval.xs : _a, _b = options.evaluator, evaluator = _b === void 0 ? defaultWorkRequestEval : _b;
    return retry_1.retry(workRequestFn)
        .then(function (workRequestResponse) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    probes.forEach(function (probe) { return probe(mutationArgs, workRequestResponse); });
                    if (!!evaluator(mutationArgs, workRequestResponse)) return [3 /*break*/, 2];
                    return [4 /*yield*/, retry_1.timeout(pollingInterval)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, watchWorkRequest(mutationArgs, workRequestFn, options, probes)];
                case 2: return [2 /*return*/, Promise.resolve(workRequestResponse)];
            }
        });
    }); })
        .catch(function (err) { return Promise.reject(err); });
}
/**
 * Wraps a method with a work request polling operation
 * @param mutationMethod A method that initiates the work request
 * @param workRequestMethod A method to poll the work request
 * @param options Additional options to configure work request polling
 */
function withWorkRequest(mutationMethod, workRequestMethod, options) {
    var _this = this;
    var registeredProbes = [];
    var asyncAction = function (args) { return __awaiter(_this, void 0, void 0, function () {
        var mutationResult, workRequestId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mutationMethod(args)];
                case 1:
                    mutationResult = _a.sent();
                    if (response_1.isResponseWithData(mutationResult)) {
                        workRequestId = mutationResult.response.headers.get("opc-work-request-id");
                    }
                    else {
                        workRequestId = mutationResult.headers.get("opc-work-request-id");
                    }
                    if (workRequestId) {
                        return [2 /*return*/, watchWorkRequest(args, function () { return workRequestMethod({ workRequestId: workRequestId }); }, options, registeredProbes)];
                    }
                    console.error("No opc-work-request-id in response, returning response");
                    return [2 /*return*/, mutationResult];
            }
        });
    }); };
    asyncAction.probe = function (probe) {
        registeredProbes.push(probe);
        return function () { return registeredProbes.splice(registeredProbes.indexOf(probe), 1); };
    };
    return asyncAction;
}
exports.default = withWorkRequest;
//# sourceMappingURL=withWorkRequest.js.map